<script setup lang="ts">
import formatBytes from "@/helpers/files/formatBytes";
import isPDFFile from "@/helpers/files/isPDFFile";
import type { IFileState } from "@/interfaces";
import SVG from "@/stories/displays/SVG/SVG.vue";
import type { SVGName } from "@/SVGs";
import { computed, toRefs } from "vue";

interface Props {
  file: IFileState;
  customStyles?: string;
}

const props = withDefaults(defineProps<Props>(), {
  customStyles: "min-w-160 w-160 h-160 min-h-160 rounded-2xl",
});
const { file } = toRefs(props);

const icon = computed<SVGName>(() => {
  if (file.value.type && isPDFFile(file.value.type)) {
    return "far-file-pdf";
  }

  return "far-file-lines";
});
</script>

<template>
  <button
    type="button"
    class="overflow-hidden block hover:scale-105 transition-transform px-4 bg-neutral100"
    :class="[customStyles]"
    @click="$emit('click')"
  >
    <div class="flex flex-col gap-1">
      <div class="flex justify-center">
        <SVG :icon="icon" height="2.5rem" width="2.5rem" />
      </div>
      <div v-if="file.name" class="b300 text-neutral1000 truncate">
        {{ file.name }}
      </div>
      <div v-if="file.size" class="b300 text-neutral700 truncate">
        {{ formatBytes(file.size) }}
      </div>
    </div>
  </button>
</template>
